import React, { useContext, useEffect, useMemo } from 'react';
import { useTable, useSortBy, useFilters, useGlobalFilter, usePagination } from 'react-table';
import ColumnFilter from './ColumnFilter';
import GlobalFilter from './GlobalFilter';
import { AiOutlineFilePdf } from 'react-icons/ai';
import logo from '../../../assets/logo.avif';
import { LoginContext } from '../../../reactcontext/ReactContext';

function PaymentTable({ data, columns, allPayments}) {
  const { loginInfo } = useContext(LoginContext);

  const printedBy = loginInfo?.userDetails
    ? `${loginInfo.userDetails.firstName} ${loginInfo.userDetails.lastName}`
    : 'Admin';

  function getReadableTimestamp() {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;
  }

  const exportPDF = () => {
    if (!data || data.length === 0) { alert('No data available to export.'); return; }
    const html2pdf = require('html2pdf.js');
    const tdStyle = 'padding:4px 6px;border:1px solid #e5e7eb;';
    const rows = data.map((r, i) => {
      const name = r.paymentInit?.Employee ? `${r.paymentInit.Employee.firstName} ${r.paymentInit.Employee.lastName}`.trim() : (r.fullName || 'N/A');
      const idNo = r.passportNumber || r.paymentInit?.Employee?.Passports?.[0]?.passportNo || 'N/A';
      const year = r.paymentInit?.year || r.year || 'N/A';
      const total = r.paymentInit?.amount ?? r.initialAmount ?? 0;
      const paid = r.totalPayments ?? r.totalPaid ?? 0;
      const due = r.balance ?? r.dueBalance ?? (parseFloat(total) - parseFloat(paid));
      return `<tr style="background:${i % 2 === 0 ? '#fff' : '#f9fafb'}">
        <td style="${tdStyle}">${idNo}</td>
        <td style="${tdStyle}">${name}</td>
        <td style="${tdStyle}">${year}</td>
        <td style="${tdStyle}">${parseFloat(total).toLocaleString()}</td>
        <td style="${tdStyle}">${parseFloat(paid).toLocaleString()}</td>
        <td style="${tdStyle}">${parseFloat(due).toLocaleString()}</td>
      </tr>`;
    }).join('');
    const el = document.createElement('div');
    el.style.cssText = 'padding:20px;font-family:Arial,sans-serif;font-size:11px;';
    el.innerHTML = `
      <div style="text-align:center;margin-bottom:14px;">
        <img src="${logo}" style="width:60px;display:block;margin:0 auto 6px auto;" crossorigin="anonymous"/>
        <div style="font-size:16px;font-weight:bold;margin:4px 0;">Rahman Group</div>
        <div style="font-size:13px;margin:2px 0;">Report Listing - Payments</div>
      </div>
      <div style="display:flex;gap:30px;flex-wrap:wrap;margin-bottom:12px;">
        <span><em>Printed By:</em> <strong>${printedBy}</strong></span>
        <span><em>Printed On:</em> <strong>${getReadableTimestamp()}</strong></span>
        <span><em>Total Records:</em> <strong>${data.length}</strong></span>
        <span><em>Signature:</em> <strong>______________</strong></span>
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:10px;">
        <thead><tr style="background:#e5e7eb;">
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Passport No</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Full Name</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Year</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Total Amount</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Payment Amount</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Due</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>`;
    html2pdf().set({
      margin: 10,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
    }).from(el).outputPdf('blob').then(blob => {
      window.open(URL.createObjectURL(blob), '_blank');
    });
  };

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter
    }
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,  
    setGlobalFilter, 
  } = useTable({ columns, data, defaultColumn} , useFilters, useGlobalFilter, useSortBy, usePagination)

  const { globalFilter, pageIndex, pageSize } = state

  useEffect(() => {
    setPageSize(20)
  }, [])

  return (

    <>
  
      {/* On desktop */}
      <div className="container mx-auto py-6 px-4 w-full">
  {/* Filter Section */}
  <div className="mb-4 flex flex-col sm:flex-row gap-4 items-center justify-between">
    <div className="w-full sm:max-w-md">
      <div className="relative">
        <GlobalFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          placeholderText="Search ..."
          className="w-full pl-12 pr-4 py-3 rounded-full shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent text-gray-700 font-medium border border-gray-300 bg-white transition-all duration-200 hover:shadow-xl"
        />
        <div className="absolute top-1/2 left-4 transform -translate-y-1/2 inline-flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5 text-gray-400"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="10" cy="10" r="7" />
            <line x1="21" y1="21" x2="15" y2="15" />
          </svg>
        </div>
      </div>
    </div>
    <button
      onClick={exportPDF}
      disabled={!data || data.length === 0}
      className={`p-2 gap-1 flex items-center justify-center text-sm rounded-md shadow font-light ${
        !data || data.length === 0 ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600 text-white'
      }`}
    >
      <AiOutlineFilePdf fontSize={20} />
      Export PDF
    </button>
  </div>

  {/* Table Section */}
  <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative">
    <table
      {...getTableProps()}
      className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative"
    >
      <thead>
        {headerGroups.map(headerGroup => (
          <tr
            {...headerGroup.getHeaderGroupProps()}
            className="text-left bg-gray-100"
          >
            {headerGroup.headers.map(col => (
              <th
                {...col.getHeaderProps(col.getSortByToggleProps())}
                className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs"
                key={col.id}
              >
                {col.render("Header")}
                <span>
                  {col.isSorted ? (col.isSortedDesc ? " ▼" : " ▲") : ""}
                </span>
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody {...getTableBodyProps()}>
        {page.map(row => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className="border-dashed border-t border-gray-200 hover:bg-gray-300 transition duration-300 ease-in-out"
              key={row.id}
            >
              {row.cells.map(cell => (
                <td
                  {...cell.getCellProps()}
                  className="whitespace-nowrap border-dashed border-t border-gray-200 px-6 py-4"
                  key={cell.column.id}
                >
                  {cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>

  {/* Pagination Controls */}
  <div className="flex justify-between items-center py-4">
    <span>
      Page <strong>{pageIndex + 1} of {pageOptions.length}</strong>
    </span>
    <div className='flex gap-2'>
      <button
        onClick={() => gotoPage(0)}
        disabled={!canPreviousPage}
        className="px-3 py-1 bg-gray-200 rounded text-gray-600 hover:bg-gray-300 disabled:bg-gray-100"
      >
        {"<<"}
      </button>
      <button
        onClick={() => previousPage()}
        disabled={!canPreviousPage}
        className="px-3 py-1 bg-gray-200 rounded text-gray-600 hover:bg-gray-300 disabled:bg-gray-100"
      >
        Previous
      </button>
      <button
        onClick={() => nextPage()}
        disabled={!canNextPage}
        className="px-3 py-1 bg-gray-200 rounded text-gray-600 hover:bg-gray-300 disabled:bg-gray-100"
      >
        Next
      </button>
      <button
        onClick={() => gotoPage(pageCount - 1)}
        disabled={!canNextPage}
        className="px-3 py-1 bg-gray-200 rounded text-gray-600 hover:bg-gray-300 disabled:bg-gray-100"
      >
        {">>"}
      </button>
      {/* <span className="ml-3">
        Go to page:
        <input
          type="number"
          defaultValue={pageIndex + 1}
          onChange={e => {
            const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
            gotoPage(pageNumber);
          }}
          className="w-10 border-2 bg-gray-300 rounded-md px-1 ml-1"
        />
      </span>
      <select
        value={pageSize}
        className="border-2 bg-gray-300 mx-1 px-1 py-[2px] rounded-lg"
        onChange={e => setPageSize(Number(e.target.value))}
      >
        {[5, 10, 15, 20, 25, 100].map(size => (
          <option value={size} key={size}>
            Show {size}
          </option>
        ))}
      </select> */}
    </div>
  </div>
</div>

    </>
  )
}

export default PaymentTable;
